import * as Util from "../common/util";
import * as Data from "../interfaces/data";

export interface ITemplatePhraseImportResponse {
    ErrorMessages: string[];
    ValidPhrases: ITemplatePhraseInfo;
    InvalidPhrases: ITemplatePhraseInfo;
    CanImport: boolean;
}

export interface ITemplatePhraseImportRequest {
    UploadSessionID: number;
    TemplatePhraseID: number;
    AppendToExistingPhrases: boolean;
}

export interface ITemplatePhraseInfo {
    Phrase: string;
    ErrorMessages: string[];
}

export function ValidateFile(request: ITemplatePhraseImportRequest): JQueryDeferred<Data.IResponse<ITemplatePhraseImportResponse>> {
    return Util.callWebService(
        "/api/TemplatePhraseDetail/Validate", "POST", request);
}

export function Import(request: ITemplatePhraseImportRequest): JQueryDeferred<Data.IResponse<ITemplatePhraseImportResponse>> {
    return Util.callWebService(
        "/api/TemplatePhraseDetail/Import", "POST", request);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/data/templatePhraseImportData.ts